import React from "react";
import ModalFooter from "components/BaseModalComponents/Footer/ModalFooter";
import BasedModal, { IProps } from "../BaseModalComponents/BasedModal";
import {
    Container,
    ModalBody,
    ModalDescription,
    ModalTitle,
} from "./areYouSureModalStyles";

const bodyStyle = {
    padding: 15,
    fontSize: 20,
    fontWeight: "bold",
    alignItems: "center",
    wordBreak: "break-word" as const,
    overflowWrap: "break-word" as const,
};

const style = {
    justifyContent: "space-evenly",
};

function AreYouSureModal({
    isOpen,
    title,
    description,
    onRequestClose,
    onApplyClick,
    listTitle,
    listItems,
}: IProps) {
    return (
        <BasedModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <Container id="modal_confirm">
                <ModalBody style={bodyStyle as object}>
                    <ModalTitle>{title}</ModalTitle>
                    {description && (
                        <ModalDescription>{description}</ModalDescription>
                    )}
                    {listTitle && listItems && listItems.length > 0 && (
                        <div style={{ padding: "8px 4px", fontSize: "12px" }}>
                            <strong style={{ textAlign: "center" }}>
                                {listTitle}
                            </strong>

                            <ul
                                style={{
                                    marginTop: "4px",
                                    maxHeight: "300px",
                                    overflow: "scroll",
                                }}
                            >
                                {listItems.map((file, i) => (
                                    <li
                                        key={i}
                                        style={{ fontWeight: "normal" }}
                                    >
                                        {file}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter
                    onCancelClick={onRequestClose}
                    onApplyClick={onApplyClick}
                    style={style}
                    applyText="Да"
                    cancelText="Нет"
                />
            </Container>
        </BasedModal>
    );
}

export default AreYouSureModal;
